<template>
  <div class="relative">
    <input v-model="localValue" class="search-input font-sans" placeholder="Search" />

    <inline-svg class="search-icon" :src="require('../../../assets/img/icons/search.svg')"></inline-svg>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/sass/base/_vars.scss";

.search-input {
  background: $secondaryGrey;
  height: 40px;
  border-radius: 4px !important;
  padding: 0 16px;
  border: none;
  width: 100%;
  margin-bottom: 20px;
}

.search-icon {
  position: absolute;
  right: 6px;
  top: 0;
}
</style>
<script>
import InlineSvg from "vue-inline-svg";

export default {
  components: {
    InlineSvg,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
